import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Loader from "../../component/loaderComponent/Loader";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import Header from "../../component/Header/Header";
import Footer from "../../component/Footer/Footer";
import Sidebar from "../Sidebar/index";
import "./partcatelogue.scss";
import Pagination from "../../component/Pagination/PgmTextField";
import { useNavigate } from "react-router-dom";
import PartorderlistButtons from "../../component/PartorderslistButtons";
import { partcatelogueAction,partCateloguePageValue } from "../../actions/partcatelogueAction";
import { safeEncode } from "../../common/encoder";
import { useSelector } from "react-redux";
import NodataFound from "../../component/NodataFound";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { hasPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";

function PartCatelogue() {
  const pagedata=useSelector((state)=> state.partCatalougePage);
  const [partcatelogues, setPartCatelogues] = useState([]);
  const [isLoading, setIsLoading] = useState(true); 
  const [cataloguefile, setcataloguefile] = useState("");
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(pagedata?.page);
  const [startIndex, setStartIndex] = useState(1);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");

  useEffect(() => {
    PartCatelogueData();
    handleChangeLanguage(language);
  }, [page]);

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  const handlePageChange = (event, value) => {
    dispatch(partCateloguePageValue(value));
    setPage(value);
  };
  const Addcatelogue = () => {
    navigate("/addcatelogue")
  }
  const Editcatelogue = (Id) => {
    window.scroll(0, 0);
    const encodeid = safeEncode(Id);
    navigate(`/editcatelogue/${encodeid}`);
  };



  async function PartCatelogueData() {
    const newStartIndex = (page - 1) * 15 + 1;
    setStartIndex(newStartIndex);
    setIsLoading(true);
    let response = await dispatch(partcatelogueAction(page));
    if (response == 200 || response != null) {
      if (response.data.data.count % 15 == 0) {
        setCount(Math.floor(response.data.data.count / 15))
      }
      else {
        setCount(Math.floor((response.data.data.count / 15) + 1))
      }
      setIsLoading(false);
      setPartCatelogues(response.data.data.results);
      setcataloguefile(response.data.data.results.catalogue_file);
    }
    else if (response === undefined) {
      setIsLoading(false);
    }
  }

  return (

    <div className="partcatelogue_containers">
      <div className="partcatelogue_container">
        <div className="partcateloguemain">
          <div className="header_border tvsparts_text">
          TVS &gt; {t('partcatalogues.partcatelogue')}
          </div>
          <div className="partcateloguebuttons_container">
            {/* <div className="partcateloguebutton">
            <button className="part_catelogue_buttons" onClick={parts}>Parts</button>
            <button className="part_catelogue_buttons" onClick={orders}>Orders</button>
            <button className="part_catelogue_addbuttons" onClick={PartCatelogue}>Parts Catalogue</button>
           </div> */}
            <div>
              <PartorderlistButtons />
            </div>
            <div>
              {hasPermission(PERMISSIONS.CAN_CREATE_PART_CATALOGUE) && (
                <button className="part_catelogue_addbuttons" onClick={Addcatelogue}>{t('partcatalogues.addcatalogue')}</button>
              )}
            </div>
          </div>

          <div className="pagination_margin">
            {isLoading ? (
              <Loader />
            ) : (
              <div className="tabledata">
                {partcatelogues?.length > 0 ?
                  <table className="table">
                    <tr>
                      <th className="tablesth"> {t('pgmlist.sNo')}</th>
                      <th className="tablesth"> {t('partcatalogues.image')}</th>
                      <th className="tablesth">{t('partcatalogues.vehiclename')}</th>
                      {hasPermission(PERMISSIONS.CAN_VIEW_PART_CATALOGUE_DETAILS) &&(
                        <th className="tablesth"></th>
                      )}
                    </tr>
                    {partcatelogues?.map((data, ind) =>
                      <tr>
                        <td className="tabletd">{ind + startIndex}</td>
                        <td className="tabletd"><img className="part-img-cateloguues" src={data.catalogue_image ? data.catalogue_image : Image_Url.PARTCATELOGUE} alt="partcatelogue" /></td>
                        <td className="tabletd">{data.vehicle_name}</td>
                        {hasPermission(PERMISSIONS.CAN_VIEW_PART_CATALOGUE_DETAILS) && (
                          <td
                            className="tabletd_view"
                            onClick={() => {
                              Editcatelogue(data.id);
                            }}
                          >
                            {t('partlist.edit')}
                          </td>
                        )}
                      </tr>
                    )}
                  </table>
                  :
                  <NodataFound/>
                }
              </div>
            )}
            <div className="pagination-div">
              <Pagination count={count} page={page} handlePageChange={handlePageChange}/>
            </div>
            <div>
            </div>
          </div>

          <div className="footer_div">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartCatelogue;
